import React from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import DynamicRoleShellLayout from "./DynamicRoleShellLayout";
import DynamicRoleDashboard from "./dashboards/DynamicRoleDashboard";
import { isReservedRoleShellSegment } from "./reservedRouteSegments";

function DynamicRoleShellEntry() {
  const { roleSlug } = useParams();
  if (isReservedRoleShellSegment(roleSlug)) {
    return <Navigate to="/" replace />;
  }
  return <DynamicRoleShellLayout />;
}

/**
 * Fallback shell for any mst_roles.role_slug without a dedicated dashboard in roleShellConfig.
 * URL: /<role-slug>/dashboard (matches login redirect and nav sync).
 */
export function DynamicRoleShellRoutes() {
  return (
    <Route path="/:roleSlug" element={<DynamicRoleShellEntry />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<DynamicRoleDashboard />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Route>
  );
}
